module.exports = __webpack_public_path__ + "img/sol_cap5.f1517799.png";